import {Colors} from '@eitje/assets'

export const LINE_COLORS = [
	Colors.mediumBlue,
	Colors.mediumGreen,
	Colors.mediumOrange,
	Colors.mediumFuchsia,
	Colors.mediumRed,
	Colors.mediumYellow,
	Colors.mediumPink,
	Colors.mediumPurple,
	Colors.mediumBrown,
]

export const FONT_FAMILY =
	"'system-ui', BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
